/**
 * Quando o estado de pagamento da venda impede um atalho (feature 013, G5 /
 * AD-178).
 *
 * Domínio **puro**. Existe para o comando (`acionarCenario`) e para a faixa
 * (`DicaAtalhos`) responderem a **mesma** pergunta: sem este módulo cada um a
 * escreveria por conta própria, e o botão voltaria a parecer acionável numa
 * venda em que o clique recusa — foi o que aconteceu até a correção do usuário
 * de 2026-10-19.
 */

import type { AtalhoVendaRapida } from './tipos';

/**
 * O que da venda importa para o conflito: a condição vigente e se há forma
 * **viva** (`haPagamentoVivo`, de `saldoPagamento`). Lidos separados de
 * propósito — uma venda retomada (006/011) tem forma sem condição selecionada.
 */
export interface PagamentoDaVenda {
  readonly condicaoCodigo: number | null;
  readonly temFormaAplicada: boolean;
}

/**
 * O atalho carrega um par (condição, forma) e cada venda aceita uma condição
 * só, então ele **não** vale quando a venda:
 *
 * - já tem forma viva — mesmo sob a mesma condição, é o que impede o atalho de
 *   dividir o pagamento e de lançar por cima de um documento retomado já pago;
 * - ou já escolheu **outra** condição. A condição igual não conflita: é o caso
 *   de um atalho que falhou depois de selecioná-la (TEF recusado, veredito da
 *   014) e está sendo repetido, e travá-lo faria o próprio atalho envenenar a
 *   retentativa.
 */
export function conflitaComOutroPar(
  atalho: Pick<AtalhoVendaRapida, 'condicaoCodigo'>,
  venda: PagamentoDaVenda,
): boolean {
  return (
    venda.temFormaAplicada ||
    (venda.condicaoCodigo !== null && venda.condicaoCodigo !== atalho.condicaoCodigo)
  );
}
